import { gql } from '@apollo/client';

export const ASSIGN_NEXT_POD = gql`
  mutation assignNextPod($jobListId: String!) {
    assignNextPod(jobListId: $jobListId) {
      success
    }
  }
`

export const ASSIGN_INSPECTOR_V2 = gql`
  mutation assignInspectorV2($data: AssignInspectionInputV2!, $workshopId: String!) {
      assignInspectionToCgtV2(data: $data, workshopId: $workshopId) {
        success
    }
  }
`;

export const ASSIGN_TECHNICIAN_TO_WORKSHOP_BAY = gql`
  mutation assignTechnicianAndWorkshopBay($jobListId: String!, $technicianId: String!, $workshopBayId: String!){
    assignTechnicianAndWorkshopBay(jobListId: $jobListId, technicianId: $technicianId, workshopBayId: $workshopBayId){
     success
     jobList{
        id
        technicianAssigned{
          id
          username
       }
       jobCardStatus{
          label
          color
      }
     }
    }
  }
`;
